<template>
  <div>
    <div v-if="success" class="alert alert-success text-center">
      <h2><i class="fa fa-check-circle"/></h2>
      <div>HEMOS RECIBIDO EL PAGO CORRECTAMENTE</div>
      <small>- {{PaymentResult.Ds_Date}} {{PaymentResult.Ds_Hour}} -</small>
      <br>
      <br>
      <small>NUMERO PEDIDO</small>
      <br>
      <strong>{{PaymentResult.Ds_Order}}</strong>
      
    </div>
    <div v-else-if="error" class="alert alert-danger text-center">
      <i class="fa fa-times" />
      <br>
      <small>NO SE PUDO PROCESAR EL PAGO</small>
      <p>{{PaymentResult.Ds_ResponseMessage.toUpperCase()}}</p>
    </div>
    <div v-else class="alert alert-warning text-center">
      <i class="fa fa-sync fa-spin" />
      PENDIENTE
    </div>
  </div>
</template>
<script>
export default {
  props: {
    PaymentResult: {}
  },
  computed: {
    error() {
      return this.PaymentResult && this.PaymentResult.Ds_Response !== '0000'
    },
    success() {
      return this.PaymentResult && this.PaymentResult.Ds_Response === '0000'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Payment/PaymentStatus.vue